/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetFileRenditionContentQueryResponse, FilesControllerGetFileRenditionContentPathParams } from "../../models/filesController/FilesControllerGetFileRenditionContent";

function getFilesControllerGetFileRenditionContentUrl(id: FilesControllerGetFileRenditionContentPathParams["id"], renditionId: FilesControllerGetFileRenditionContentPathParams["renditionId"]) {
  const res = { method: 'GET', url: `/api/v1/files/${id}/renditions/${renditionId}/content` as const }  
  return res
}

/**
 * @description Returns the content of a file rendition, proxied through the API to avoid CORS issues.
 * @summary Get file rendition content
 * {@link /api/v1/files/:id/renditions/:renditionId/content}
 */
export async function filesControllerGetFileRenditionContent(id: FilesControllerGetFileRenditionContentPathParams["id"], renditionId: FilesControllerGetFileRenditionContentPathParams["renditionId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerGetFileRenditionContentQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getFilesControllerGetFileRenditionContentUrl(id, renditionId).url.toString(), ... requestConfig })  
  return res.data
}